import React from 'react'
import i18n from 'i18next'

import Typography from '../../../UniformComponents/Typography'

const MatrixExplainer = () => {
    const chartData = [
        {
            name: 'Hostages',
            list: [
                i18n.t('powerpoint.matrixexplainer.hostages.1'),
                i18n.t('powerpoint.matrixexplainer.hostages.2'),
                i18n.t('powerpoint.matrixexplainer.hostages.3'),
                i18n.t('powerpoint.matrixexplainer.hostages.4'),
            ],
        },
        {
            name: 'Apostles',
            list: [
                i18n.t('powerpoint.matrixexplainer.apostles.1'),
                i18n.t('powerpoint.matrixexplainer.apostles.2'),
                i18n.t('powerpoint.matrixexplainer.apostles.3'),
                i18n.t('powerpoint.matrixexplainer.apostles.4'),
            ],
        },
        {
            name: 'Disaffected',
            list: [
                i18n.t('powerpoint.matrixexplainer.disaffected.1'),
                i18n.t('powerpoint.matrixexplainer.disaffected.2'),
                i18n.t('powerpoint.matrixexplainer.disaffected.3'),
                i18n.t('powerpoint.matrixexplainer.disaffected.4'),
            ],
        },
        {
            name: 'Mercenaries',
            list: [
                i18n.t('powerpoint.matrixexplainer.mercenaries.1'),
                i18n.t('powerpoint.matrixexplainer.mercenaries.2'),
                i18n.t('powerpoint.matrixexplainer.mercenaries.3'),
                i18n.t('powerpoint.matrixexplainer.mercenaries.4'),
            ],
        },
    ]

    const renderDataBlocks = (data) => (
        <div className={`dataBlock ${data.name}`}>
            <div className="dataContainer">
                <div className="mainData">
                    <div className={`subText ${data.name}`}>
                        {data.name}
                    </div>

                    <div style={{ display: 'flex', gap: 10, height: '100%', textAlign: 'left', overflowY: 'auto' }}>
                        <ul style={{ paddingLeft: 20 }}>
                            {data.list.map((l) => <li><Typography type="tiny">{l}</Typography></li>)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <div style={{ height: '100%', marginTop: 60 }}>
            <div className="pp-chart-slot-container lmx-chart-slot">
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', backgroundColor: 'white', borderRadius: 6, padding: '5px 10px' }}>
                    <div className="pp-lmx" style={{ minHeight: '400px', width: '100%', height: '100%', minWidth: 500 }}>
                        <div className="pp-lmxExplainerContainer">
                            <div className="pp-lmxGraph">
                                <Typography cssClass="yLabel">Loyalty</Typography>
                                <Typography cssClass="xLabel">Satisfaction</Typography>
                                {renderDataBlocks(chartData[0])}
                                {renderDataBlocks(chartData[1])}
                                {renderDataBlocks(chartData[2])}
                                {renderDataBlocks(chartData[3])}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MatrixExplainer
